import React from 'react';

/** Tab bar matching facturation/Products.js create-edit modal style. */
export default function InventaireFormTabBar({
  tabs,
  activeTab,
  onTabChange,
  isLight = false,
  ariaLabel,
}) {
  return (
    <div className={`shrink-0 px-6 pt-3 border-b ${isLight ? 'border-gray-200' : 'border-white/10'}`}>
      <div className="flex flex-wrap gap-1" role="tablist" aria-label={ariaLabel}>
        {tabs.map((tab) => {
          const TabIcon = tab.icon;
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onTabChange(tab.id)}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-t-xl text-sm font-semibold transition-colors ${
                active
                  ? (isLight
                    ? 'bg-[#6e9b6e]/15 text-forest-900 border-b-2 border-[#6e9b6e] -mb-px'
                    : 'bg-white/10 text-white border-b-2 border-blue-400 -mb-px')
                  : (isLight
                    ? 'text-gray-600 hover:text-gray-900 hover:bg-gray-100/80'
                    : 'text-white/55 hover:text-white hover:bg-white/5')
              }`}
            >
              {TabIcon ? (
                <TabIcon
                  size={16}
                  className={active ? (tab.iconClassName || 'text-blue-400') : ''}
                />
              ) : null}
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
